import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  DeleteIconButton,
  EditIconNavButton,
  ViewIconNavButton,
} from "../../../components/Buttons";
import {
  createSortById,
  scrollToTop,
  TableEmptyMessage,
  toUIDate,
} from "../../../components/Utils";
import TablePageReport from "../../../components/TablePageReport";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import { loadNews, deleteArticle } from "../actions";
import ConfirmationDialog from "../../../components/ConfirmationDialog";

const frontload = async (props) => {
  await props.getNews({ categoryName: props.categoryName });
};
const mapStateToProps = (state) => {
  return {
    isLoading: state.news.loading,
    newsSummaries: state.news.teasers,
  };
};
const mapDispatchToProps = (dispatch) => ({
  getNews: (...args) => dispatch(loadNews(...args)),
  deleteArticle: (...args) => dispatch(deleteArticle(...args)),
});

function NewsArticleTable({
  isLoading,
  newsSummaries,
  deleteArticle,
  rows = 10,
  className = "",
  categoryName = "General",
  disabled,
}) {
  const confirmRef = React.useRef(null);
  const [first, setFirst] = React.useState(0);
  React.useEffect(() => {
    scrollToTop();
  });

  const onPage = (event) => setFirst(event.first);
  const onEditArticle = (newsItem, history) => {
    let url = `/news-service/beitrag/${encodeURIComponent(newsItem.id)}`;
    if (categoryName === "Sales") {
      url = `/sales/news-feed/beitrag/${encodeURIComponent(newsItem.id)}`;
    }
    history.push(url);
  };
  const onDeleteArticle = (newsItem) => {
    confirmRef.current.show(
      true,
      {
        title: "Beitrag löschen",
        text: `Wollen Sie diesen Beitrag "${newsItem.title}" wirklich löschen?`,
      },
      () => deleteArticle(newsItem, categoryName),
    );
  };
  const actionTemplate = (rowData) => {
    const NavButton = disabled ? ViewIconNavButton : EditIconNavButton;
    return (
      <div /* style={{display:"flex", gap:"4px"}} */>
        <NavButton
          id={`editNewsBtn${rowData.id}`}
          onClick={(history) => onEditArticle(rowData, history)}
        />
        <DeleteIconButton
          id={`deleteBtn${rowData.id}`}
          onClick={() => onDeleteArticle(rowData)}
          title="löschen"
        />
      </div>
    );
  };

  const data = (newsSummaries || [])
    .map((newsItem, index) => ({
      ...newsItem,
      index,
      changeDate: toUIDate(
        newsItem.modified_date || newsItem.publication_date,
      ),
    }))
    // sort by id in descending order
    .sort(createSortById(true));
  return (
    <div className={`news-table clearfix ${className}`}>
      <DataTable
        value={data}
        rows={rows}
        first={first}
        onPage={onPage}
        paginator={data.length > rows}
        paginatorLeft={
          <TablePageReport
            className="pad-lft"
            totalRecords={data.length}
            filteredRecords={data.length}
            first={first}
            rows={rows}
            emptyText="Keine Beiträge"
            itemName="Beitrag"
            itemNamePlural="Beiträge"
          />
        }
        removableSort
        sortMode="multiple"
        emptyMessage={
          isLoading ? null : <TableEmptyMessage itemNamePlural="Beiträge" />
        }
      >
        <Column
          field="title"
          header="Titel"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
        />
        <Column
          field="visibility"
          header="Sichtbarkeit"
          className="alg-center"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
          style={{ width: "10em" }}
        />
        <Column
          field="changeDate"
          header="Zuletzt geändert"
          className="alg-center"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
          style={{ width: "12em" }}
        />
        <Column
          body={actionTemplate}
          className="alg-center"
          style={{ width: "7.4em" }}
        />
      </DataTable>
      <ConfirmationDialog
        ref={confirmRef}
        // showReason={showItemDeleteReason || showItemCloseReason}
      />
    </div>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(NewsArticleTable),
);
